export const isProduction = () => {
    if (window.location.href.indexOf('https://subscribe.') >= 0)
        return true;
    return false;
};